import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {LinkContainer} from 'react-router-bootstrap'
import { Glyphicon, Button } from 'react-bootstrap'
import Logger from '../stores/Logger'

class Forbidden extends Component {
    render() {
        const {stores} = this.props
        const {routingStore} = stores
        const {location} = routingStore
        Logger.trackEvent('403', 'page', location.pathname)

        return (
            <div style={{textAlign:"center"}}>
                <h1>403 - Forbidden</h1>
                <div>You are not allowed to view this idea, please verify that you have logged in with the email address that you were invited with.</div>

                <LinkContainer to='/'>
                    <Button bsStyle='primary'>Go Back</Button>
                </LinkContainer>

                <div><em>Have a nice day!</em></div>
                <h1><Glyphicon glyph='thumbs-up'/></h1>
            </div>
        )
    }
}

export default inject("stores")(observer(Forbidden))



// WEBPACK FOOTER //
// ./src/containers/Forbidden.js